 

function BuyCard(probs) {

    return ( 
       <>
         <div className="card mb-4 d-flex flex-column flex-md-row align-items-center">
                <div className="circle d-flex align-items-center justify-content-center mb-3 mb-md-0">{probs.order}</div>
                <div className="ms-0 ms-md-3 text-center text-md-start">
                  <h5 className="card-title">{probs.title}</h5>
                  <p className="card-text">{probs.detail}</p>
                </div>
          </div>
       </> 
 ); 

}

export default BuyCard;